<template>
  <div class="no-content">
    <p v-if="title" v-html="title" class="title" />
    <font-awesome-icon :class="iconClass" :icon="iconName" />
    <p class="mb-0">
      {{ text }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    title: String,
    iconName: {
      type: String,
      required: true,
    },
    iconClass: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" scoped>
.no-content {
  text-align: center;
  background-color: inherit;
  padding: 4rem 0rem !important;
  color: var(--noContentColor) !important;
}

.no-content p {
  font-size: 1.2rem;
}

.no-content .title {
  font-size: 1rem;
}
</style>
